import * as apiRoutes from '../../apiRoutes';
import { AuthUrl, errorTypes } from "../../constants";
import * as api from '../../tools/apiMiddleware';
import { actionTypes } from '../../actionTypes';

const initialState = {
    gatewayUri: undefined,
    userGotDisabled: false,
    isLoading: false,
    hasErrorOccured: false,
    loggedOut: false
};

export const actionCreators = {
    getGateway: () => async (dispatch, getState) => {
        let url = AuthUrl + apiRoutes.GetGateway;
        await api.getRequest(dispatch, url, actionTypes.GET_GATEWAY, actionTypes.GET_GATEWAY_SUCCESS, actionTypes.GET_GATEWAY_FAIL);
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case actionTypes.GET_GATEWAY:
            return {
                ...state,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.GET_GATEWAY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                gatewayUri: action.data.redirectUri,
                hasErrorOccured: false
            };
        case actionTypes.GET_GATEWAY_FAIL:
            return {
                ...state,
                isLoading: false,
                hasErrorOccured: true,
                errorData: action.data,
                loggedOut: action.data.errorType === errorTypes.Unauthorized
            };
        default:
            return state;
    }
    
};


// WEBPACK FOOTER //
// ./src/store/Auth/GatewayStore.js